import React, { useContext } from 'react';

import { Divider } from '@rbilabs/universal-components';
import { useStoreContext } from 'features/store';

import { TopOrderStatusBar } from 'components/top-order-status-bar';
import { useTopOrderStatusBar } from 'components/top-order-status-bar/use-top-order-status-bar';
import { TopServiceMode } from 'components/top-service-mode';
import { CenteredRowContainer } from 'components/ui/centered-row-container';
import { SmartAlertsContext } from 'state/smart-alert';
import { primitive } from 'styles/constants';

export const ServiceModeBar = ({
  hideTsm = false,
  hideTopOrderStatusBar = false,
  isInCart = false,
}: {
  hideTsm?: boolean;
  hideTopOrderStatusBar?: boolean;
  isInCart?: boolean;
}) => {
  const { noStoreSelected } = useStoreContext();

  const topOrderStatusBarData = useTopOrderStatusBar();
  const showTopOrderStatusBar =
    !!topOrderStatusBarData.heading &&
    topOrderStatusBarData.queryWasExecuted &&
    !hideTopOrderStatusBar;

  const showTopServiceMode = !noStoreSelected && !hideTsm;

  const { tsmSmartAlert } = useContext(SmartAlertsContext);

  const getLayoutContainerBackgroundColor = () => {
    if (showTopOrderStatusBar) {
      return primitive.$crunchyGreen;
    }
    if (tsmSmartAlert) {
      return primitive.$errorLight;
    }
    return primitive.$mayoEggWhite;
  };

  return (
    <>
      {showTopOrderStatusBar || (showTopServiceMode && <Divider />)}
      <CenteredRowContainer
        containerStyle={{
          backgroundColor: getLayoutContainerBackgroundColor(),
        }}
        standardPadding
      >
        {showTopOrderStatusBar ? (
          <TopOrderStatusBar data={topOrderStatusBarData} />
        ) : (
          showTopServiceMode && <TopServiceMode isInCart={isInCart} />
        )}
      </CenteredRowContainer>
      <Divider />
    </>
  );
};
